import Vue from 'vue';

export function handleResponseSuccess(response: any): any {
    return Promise.resolve(response)
        .then(result => {
            const data: any = {};
            if (result && result.data) {
                data.data = result.data;
            }
            if (result && result.status) {
                data.status = result.status;
                if (result.status === 201 && result.status === 200 && result.status === 204) {
                    Vue.notify({
                        group: 'notice',
                        title: result.data.title,
                        text: result.data.detail,
                        type: 'success'
                    });
                }
            }
            return data;
        })
        .catch(e => {
            throw e;
        });
}
